import { useState } from 'react';
import { Button } from '@tempmee/react';
import { DownloadReportPopup } from '../Popup';

export const DownloadReportButton = () => {
  const [isShowPopup, setIsShowPopup] = useState<boolean>(false);

  return (
    <>
      <Button data-cy="btn-export-report" size="xs" onClick={() => setIsShowPopup(true)}>
        Download Report
      </Button>
      {isShowPopup && <DownloadReportPopup onClosePopup={() => setIsShowPopup(false)} />}
    </>
  );
};
